import A from './components/A';
import B from './components/B';
import css from './index.module.scss';

export default function OverviewEU({}: any) {
    return (
        <div className={`ef-collection-pc ${css.efCollectionPC}`}>
            <A />
            <B />
        </div>
    );
}
